
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.745 4.963l4.22 4.22-8.468 8.163c-.206.192-.478.3-.76.301H2.353v-3.914c-.002-.291.114-.57.32-.774l8.072-7.996zM17.644 6.177a1.105 1.105 0 01-.34.774l-1.572 1.482-4.22-4.24 1.534-1.523a1.094 1.094 0 011.54 0l2.719 2.719c.213.207.335.49.339.788z","fill":"#002823"}}),_c('path',{attrs:{"d":"M10 16.552h7.647v1.095H10v-1.095z","fill":"#002823"}})])
          )
        }
      }
    